<script setup>
import { computed } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";

const { logout, isAuthenticated, user } = useAuth0();

const isAdmin = computed(() => {
  const roles = user.value?.['https://blything.co.uk/roles'] || [];
  return roles.includes('Admin');
});

const handleLogout = () => {
  logout({ logoutParams: { returnTo: window.location.origin } });
};
</script>

<template>
  <div>
    <div class="header grid-x">
      <!-- Added align-middle here -->
      <div class="grid-x cell align-middle small-offset-0 small-12 medium-offset-1 medium-10 large-offset-1 large-10 white-section">
        
        <div id="head-logo-mobile" class="show-for-small-only"></div>
        
        <div id="head-logo" class="cell medium-4 large-4 hide-for-small-only"></div>
        
        <div class="cell medium-8 large-8 hide-for-small-only menu-column">
          <ul v-show="isAuthenticated" id="head-menu-list">
            <router-link to="/">
              <li>
                <font-awesome-icon :icon="['fas', 'house']" />
                <span>Home</span>
              </li>
            </router-link>

            <router-link to="/profile">
              <li>
                <font-awesome-icon :icon="['fas', 'user']" />
                <span>Profile</span>
              </li>
            </router-link>

            <!-- Admin Link: Only renders if user has the Admin role -->
            <router-link v-if="isAdmin" to="/admin">
              <li>
                <font-awesome-icon :icon="['fas', 'users-gear']" />
                <span>Admin</span>
              </li>
            </router-link>

            <a @click.prevent="handleLogout" href="#">
              <li>
                <font-awesome-icon :icon="['fas', 'arrow-right-from-bracket']" />
                <span>Logout</span>
              </li>
            </a>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.white-section {
  border-radius: 0 0 16px 16px;
}
</style>

<style lang="scss">
@use "../assets/styles/header.scss";
</style>